export const getRoleTypeNameFromKey = (key: string | null | undefined) => {
  let returnString = "";
  if (key) {
    returnString = key?.split("-")[0];
  }
  return returnString;
};
